import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetReturnLossHistory from '@/modules/promotion/api/hooks/useQueryGetReturnLossHistory'
import ReturnLossHistoryListing from '@/modules/promotion/components/ReturnLossHistory/components/ReturnLossHistoryListing'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { parseAsBoolean, useQueryState } from 'nuqs'

function ReturnLossHistoryPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const { dateFilter } = useDateFilter()
	const [greaterThanZero] = useQueryState(
		'greaterThanZero',
		parseAsBoolean.withOptions({ shallow: false }).withDefault(true),
	)

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		minimumAmount: greaterThanZero ? 0 : undefined,
	}

	const { data, isLoading } = useQueryGetReturnLossHistory(payload)

	return (
		<PageContainer>
			<ReturnLossHistoryListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedReturnLossHistoryPage = withUserPermission(ReturnLossHistoryPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_RETURN_LOSS],
})

export default GuardedReturnLossHistoryPage
